// R7/R8 — THE DESKTOP SIDEBAR'S QUIET FOOTER, EXTRACTED.
//
// LG3's block, moved out of `src/App.tsx` verbatim when her support-desk clause 1 pushed that file
// over the R8 ceiling and the round paid its own ceiling as it went (App.tsx's standing law).
//
// **IT IS HOOKLESS AND TAKES PROPS, WHICH IS THE ENTRY REQUIREMENT** — so a gate CALLS it and reads
// the tree back, where a block inside a 12,000-line file could only ever be checked by regex.
//
// **AND THE ROSTER IS THE POINT OF EXTRACTING THIS ONE RATHER THAN SOMETHING ELSE.** Until her
// support-desk ruling this footer also carried `contact`, drawn as `"Contact"` at
// `site-sidebar__foot-link` weight — a second, differently-named, lighter-weight door to the page
// the mobile sheet calls **Technical Support**, sitting below the fold on a 1440x900 screen. That is
// how the support door "vanished" twice while its guard stayed green: there were two menus and only
// one was ever asked. `contact` is DELETED from this roster rather than left standing beside its
// replacement (DL-2/DT-2b/R181), and `scripts/r22-mobile-nav.mjs` now holds BOTH menus.
//
// LG3's own ruling stands: this is deliberately a different, lighter weight than a room link and is
// pinned to the bottom, so new rooms always sit above it. What may live here is legal/reference
// small print — never a door a member in trouble is hunting for.
import type { Page } from "../lib/pages";

/** The three, in order. Legal and reference only: a support door may never join this roster. */
export const SIDEBAR_FOOTER_LINKS: Array<[Page, string]> = [
  ["terms", "Terms"],
  ["privacy", "Privacy"],
  ["faq", "FAQ"],
];

export function SidebarFooterNav({ currentPage, onGo }: { currentPage: Page; onGo: (page: Page) => void }) {
  return (
    <nav className="site-sidebar__footer" aria-label="Site information">
      {SIDEBAR_FOOTER_LINKS.map(([page, label]) => (
        <button
          key={page}
          type="button"
          className={currentPage === page ? "site-sidebar__foot-link is-active" : "site-sidebar__foot-link"}
          onClick={() => onGo(page)}
        >
          {label}
        </button>
      ))}
    </nav>
  );
}
